module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Table of Contents")]), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Preface\n")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Integrity")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Has Israel Altered its Visions?")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Real Cause of My Grandmother’s Death")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Jerusalem to Cairo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between Europe and the Negev Desert")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace and Love and Compromise")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whose Holy Land?")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Telling Stories under Siege")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Israeli-Palestinian Conflict: Tragedy, Comedy and Cognitive Block")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hizbollah in a Skullcap")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clearing the Minefields of the Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read More from Amos Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0